import { Button } from "@progress/kendo-react-buttons";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { RadioGroup } from "@progress/kendo-react-inputs";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IUserCompany, useCompanies } from "../../hooks/useCompanies";
import { UserContext } from "../functional";

interface SwitchAccountsProps {
  onCancel: () => void;
}

export const SwitchAccountsDialog = (props: SwitchAccountsProps) => {
  const { onCancel } = props;
  const companies = useCompanies();
  const { user, setCompany } = useContext(UserContext);
  const [companyId, setCompanyId] = useState(user?.activeCompany.id || 0);

  const navigate = useNavigate();

  const values =
    companies?.map((c: IUserCompany) => {
      return { value: c.id, label: c.name, role: c.role };
    }) ?? [];
  values.sort((a, b) => a.label.localeCompare(b.label));

  const onSwitch = (e: any) => {
    const selectedCompany = companies.find((c: any) => c.id === companyId);
    setCompany(selectedCompany);

    navigate("/");
    window.location.reload();
  };

  return (
    <Window
      title={"Switch Company"}
      left={window.innerWidth - 500}
      top={50}
      modal={true}
      minimizeButton={() => null}
      maximizeButton={() => null}
      onClose={onCancel}
    >
      <RadioGroup data={values} value={companyId} onChange={(e: any) => setCompanyId(e.value)} />

      <WindowActionsBar layout={"center"}>
        <Button themeColor={"secondary"} size={"small"} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          themeColor={"primary"}
          size={"small"}
          disabled={companyId === 0 || companyId === user?.activeCompany.id}
          onClick={onSwitch}
        >
          Switch
        </Button>
      </WindowActionsBar>
    </Window>
  );
};
